<template>
  <div class="page" :class="bodyHide==1?'border-box overflow':''" v-wechat-title="$route.meta.title">

    <div class="main-scroll-view" style="position: relative; width: 100%; height: auto;">
      <!--关注-->
      <div class="focus" v-if="bagInfo.focushint==1&&(bagInfo.focus==0||bagInfo.focus==null)">
        <img class="icon-focus" :src="focusRes.isconfig==6?focusRes.focusimg:require('../../assets/icon-focus.png')" alt="">
        <span class="focus-txt hide">{{focusRes.isconfig==6?focusRes.focusinfo:'关注金牌解说&nbsp;&nbsp;收听更多景区讲解'}}</span>
        <span class="focus-btn" @click="focusFun()" v-if="isNaN(parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,'')))">关注</span>
        <a class="focus-btn" :href="'tel:' + parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,''))" v-else>拨号</a>
      </div>
      <div class="link-btn" @click="back" v-if="isback!=2 && !isWxMini">{{isback==1?'返回':'景区主页'}}</div>

      <div class="top-bg">
        <img class="video_play_bg" src="../../assets/video-bg.jpg" alt="">
        <div class="list-share dowm" @click="showPoster" v-if="bagInfo.download==4 && shopid!=1766">
          <img src="../../assets/icon-share-btn.png" alt="">
        </div>
      </div>
      <div class="list border-box" :class="bagInfo.download==4?'down':''">

        <div class="list-share" @click="showPoster" v-if="bagInfo.download!=4 && shopid!=1766">
          <img src="../../assets/icon-share-btn.png" alt="">
        </div>

        <!--离线下载icon-->
        <div class="download" @click="download" v-if="bagInfo.download==4">
          <img class="icon-download" src="../../assets/adot-6.png" alt="">
          {{downloadText}}
        </div>


        <div class="list-box box border-box">
          <div class="block list-img">
            <img class="img icon-tx" :src="bagInfo.guideheadimg2?bagInfo.guideheadimg2:bagInfo.guideheadimg" alt="" @click="goGuideInfo(id)">
            <img v-on:click="btnVideo()" v-if="bagInfo.video" class="video" src="../../assets/icon_play_btn10.png" alt="">
          </div>

          <div class="block flex list-info">
            <!--语音名称-->
            <p class="list-group hide">
              <span class="fl hide" style="width: 100%;">{{bagInfo.name}}</span>
            </p>

            <p class="list-name hide">
              {{bagInfo.guidename2?bagInfo.guidename2:bagInfo.guidename}}
              <span v-if="bagInfo.guidetag">/{{bagInfo.guidetag?bagInfo.guidetag:''}}</span>
            </p>


            <!--新增星级评分-->
            <div class="star-box-new clearfix">
              <img :src="(bagInfo.hotlevel>=2)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=4)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=6)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=8)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <img :src="(bagInfo.hotlevel>=10)?require('../../assets/star_curr.png'):require('../../assets/star_nor.png')" alt="">
              <span>{{bagInfo.hotlevel}}分</span>
            </div>
          </div>
        </div>

        <div v-if="bagInfo.guideinfo && bagInfo.guideinfo.length>0" class="list-box-info" :class="guideInfoState==0 && bagInfo.guideinfo && bagInfo.guideinfo.length>60?'hide2':''" @click="guideInfoStateFun">{{bagInfo.guideinfo}}</div>

        <div class="list-time-num clearfix">
          <p class="fl" v-if="bagInfo.listen">
            <img src="../../assets/adot-5.png" />
            {{bagInfo.listen|initNumber}}人收听
          </p>
          <p class="fl" v-if="(bagInfo.dsnum>0&&bagInfo.buynum<=0&&res.noReward!=1) || noBuys.indexOf(shopid)>-1">
            <img src="../../assets/adot-3.png" />
            {{bagInfo.dsnum|initNumber}}人打赏
          </p>
          <p class="fl" v-else-if="bagInfo.buynum>0&&bagInfo.price>0 && shopid!=1828">
            <img src="../../assets/adot-3.png" />
            {{bagInfo.buynum|initNumber1}}人购买
          </p>
          <!--<p class="fl list-zan" @click="videoPlayZan()" :class="res.iszan==1?'curr':''">-->
            <!--<img v-if="res.iszan==1" src="../../assets/zan_already.png" alt="">-->
            <!--<img v-if="res.iszan==0" src="../../assets/zan_already_no1.png" alt="">-->
            <!--{{bagInfo.zancounts}}-->
          <!--</p>-->
        </div>
      </div>

      <!--离线下载文字提示-->
      <!--<div class="tip-download tc" v-if="downloadTipShow==1">共{{bagList.length}}个，已经下载{{downNum}}个 <font v-if="downNumF>0">{{downNumF}}个失败</font> </div>-->
      <div class="tip-download tc" v-if="downloadTipShow==1">约{{res.totalSize}}MB，已经下载{{downMB}}MB</div>

      <!--新增打赏-->
      <div class="ds-box border-box" @click="rewardShowFun" v-if="res.noReward!=1">
        <div v-if="res.dsimgs && res.dsimgs.length>0">
          <img v-for="(item,index) in res.dsimgs"  v-if='index<6' class="img ds-box-img" v-lazy="item.rzimg?item.rzimg:item.img" :key="item.rzimg?item.rzimg:item.img"/>
          <span class="ds-box-num">已有{{bagInfo.dsnum}}人打赏</span>
        </div>
        <div v-if="!res.dsimgs||res.dsimgs.length==0">
          <span class="ds-box-num">暂无打赏</span>
        </div>
        <span class="fr ds-box-btn">打赏</span>
      </div>

      <p class="split-line" style="margin-top: .34rem;height: .02rem;background: #f1f1f1;"></p>


      <!--新增标题-->
      <div class="list-tit-new border-box clearfix">
        <span>景点解说</span>
        <span>包含{{bagInfo.sees}}个讲解点</span>
        <img class="museum_icon" :src="(museumStyle == 1)?require('../../assets/museum_icon.png'):require('../../assets/museum_icon1.png')" alt="" @click="museumStyleFun">

        <img class="list-map-icon" src="../../assets/icon_map.png" alt=""  v-if="res.ismap==1&&!isWxMini"  @click="toGiudeMap()">

      </div>

      <div style="position: relative;">
        <!--博物馆样式-->
        <div v-for="(item,index) in voice" :key="index" class="video-list museum border-box curr clearfix" :id="'museumLi'+index"   v-if="museumStyle==1">
          <p class="list-title" @click="museumCurrFun(index)">
            {{item.pspotname}}
            <img class="fr icon_sj" src= "../../assets/icon_sj.png" alt="">
          </p>

          <div class="museum-box clearfix">
            <div v-for="(ite,ind) in item.list" :key="ind" class="video-list-info" :id="'video-list-spotid'+ite.spotid">
              <div class="video-list-con  border-box" @click="listenTurlClick(ite.number)">
                <img class="img" v-lazy="ite.logo" :key="ite.number" />
                <img class="icon-play" :src="(ite.number == currIndex && isplay==1)?require('../../assets/icon-listen.gif'):require('../../assets/icon_12.png')" />
                <i class="vertical-line"></i>
                <i class="left-line" v-if="item.list.length>1"></i>
                <!--<span class="buy-state" v-if="res.isbuy==false && index==0">免费</span>-->
                <!--<span class="buy-state" v-if="res.isbuy==false && index>0">-->
                  <!--<img src="../../assets/icon_suo.png" alt="">-->
                <!--</span>-->

                <span class="buy-state" v-if="res.isbuy==false">
                  <img src="../../assets/icon_suo.png" alt="">
                </span>


              </div>
              <p class="spot-name tc border-box">{{ite.spotname}}</p>
            </div>
          </div>
        </div>

        <div v-for="(item,index) in voice" :key="index" class="video-list border-box clearfix" v-if="museumStyle==0">
          <p class="list-title">
            <img class="icon_gps" src="../../assets/icon_gps.png" />
            {{item.pspotname}}
          </p>

          <div v-for="(ite,ind) in item.list" :key="ind" class="video-list-info" :id="'video-list-spotid'+ite.spotid">
            <div class="video-list-con  border-box" :class="(ite.number==currIndex || ite.number==index1)?'curr':''">
              <img class="img" v-lazy="ite.logo" :key="ite.id" @click="listenTurlClick(ite.number,bagstyle==1?'spot':'alert')" />

              <!--this.id=='3064'&&ind<40) || ((this.id=='3592'||this.id=='3591'||this.id =='3590')&&ind>19)-->
              <p class="video-mask" :class="((id=='3064'&&ite.number<40)||((id=='3592'||id=='3591'||id=='3590')&&ite.number>19))?'none':''"  v-if="res.isbuy==false"></p>
              <img class="video-icon" src="../../assets/icon_35.png" alt="" :class="((id=='3064'&&ite.number<40)||((id=='3592'||id=='3591'||id=='3590'||id=='3598')&&ite.number>19))?'none':''"  v-if="res.isbuy==false" />

              <p class="video-see" v-if="ite.hotLevel==1">必听</p>

              <p class="video-bottom" @click="listenTurlClick(ite.number)">
                <i class="spot-play fl" :class="(ite.number == currIndex && isplay==1)?'curr':''"></i>
                <span class="video-line-white"></span>
                <span v-if="ite.number == currIndex && isplay==1">{{currTime|initTime}} / {{ite.totaltime|initTime}}</span>
                <span v-else>00:00 / {{ite.totaltime|initTime}}</span>
                <img class="fr" :src="(ite.number == currIndex && isplay==1)?require('../../assets/btn-play1.png'):require('../../assets/btn-play-off1.png')" />
              </p>
            </div>
            <p class="spot-name hide" :class="((ite.number == currIndex && isplay==1))?'curr':''">{{ite.spotname}}</p>
          </div>
        </div>


      </div>


      <!--新增附近推荐景区-->
      <div class="conference-list p024 half clearfix mt50" v-if="near&&near.length>0">
        <div class="list-tit">附近推荐景区
          <router-link class="list-more" v-if="near&&near.length>0" :to="{path:'/view-list',query:{siteid:siteid,sort:1,lat:res.bag.lat,lng:res.bag.lng,TimeStamp:TimeStamp,inputValue:'',appKey:appKeyA}}">查看更多</router-link>
        </div>
        <div>
          <div class="conference-item-parent border-box" @click="toViewDetail(item.id,item.shopType)"  v-for="(item,index) in near">
            <div class='conference-item border-box'>
              <div class="conference-item-img loadBg">
                <img class="img" v-lazy="item.logo" :key="item.id" alt="">
              </div>
              <div class="conference-item-info clearfix">
                <div class="label-box">
                  <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
                </div>
                <div class="right-info">
                  <div class='conference-item-info-label'>
                    <img src="../../assets/station-icon-view.png" alt="">
                    <span class="icon-time">{{item.spots}}个讲解点</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


      <!--新增评论头部-->
      <div class="comments-list-top clearfix border-box" id="comments-list-top">
        <span class="fl">游客点评</span>
      <span @click="commentsShow" class="fr commentBtn">我要点评
        <img src="../../assets/icon-write.png" />
      </span>
      </div>

      <!--新增底部评论详情列表-->
      <div class="comments-list border-box account-list-sr">
        <div v-for="(item,index) in commentList" :key="index" class="comments-list-data box border-box">
          <p class="block head-img-box">
            <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg" :key="item.rzimg?item.rzimg:item.headimg"/>
          </p>

          <div class="flex comments-list-info  border-box">
            <div class="comments-person-box box ">
              <div class="block comments-person">
                <p class="comments-person-name hide">{{item.name}}</p>
                <p class="star-level">
                  <template v-for="(star,index) in [2,4,6,8,10]">
                    <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                    <img v-else  src="../../assets/start_nor.png" />
                  </template>
                  <span class="icon-reward-small" v-if="item.isds&&res.noReward!=1">赏</span>
                </p>
              </div>
              <p @click="uploadZan(index)" class="praise">
                <span>{{item.totalZan}}</span>
                <img v-if="item.iszan==1" src="../../assets/zan_already.png" />
                <img v-else src="../../assets/zan_already_no.png" />
              </p>
            </div>

            <div class="comments-detail border-box">
              <p class="comments-detail-top">{{item.content}}</p>
            </div>

            <div v-if="item.allimg" class="comments-img box border-box">
              <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite"  :key="ite"/>
            </div>

            <div class="block comments-person-time">
              {{item.addtime}}
              <!--<span @click="replay" class="comments-person-hf fr" v-if="res.isguide && item.replys.length<1"><img src="../../assets/icon_play_btn11.png" />回复</span>-->
              <span v-if="item.state==2" class="shz-text fr none">审核中</span>
            </div>

            <div v-if="item.replys && item.replys.length>0" class="comments-detail-replay border-box">
              <div v-for="(item,index) in item.replys" :key="index" class="comments-replay-text">
                <span>{{item.bagname}}</span> 回复
                <span>{{item.name}}</span> ：{{item.content}}
              </div>
            </div>

            <div class="block-chain" v-if="item.code===0">
              <h3>所在区块信息</h3>
              <p>区块高度：{{item.blockNumber}}</p>
              <p>创建时间：{{item.txTime}}</p>
              <p>哈希值：<font class="p1">{{item.dataHash}}</font></p>
              <img src="../../assets/icon_36.png" alt="">
            </div>

          </div>
        </div>
        <router-link :to="{path:'/comment',query: {id:this.$route.query.id,isbuy:res.isbuy,isguide:res.isguide, TimeStamp: TimeStamp, appKey: appKeyA}}">
          <div class="bottom-box border-box">
            <p class="select-more">查看共{{commentListLen}}条评论</p>
          </div>
        </router-link>

        <p class="load-tip" ref="loadtip" style="display: none;"></p>
      </div>

    </div>

    <!--底部购买按钮-->
    <div v-if="res.isbuy==false" class="bottom-btn-box border-box box">
      <div @click="scollToComment('comments-list-top')" class="video-listen">
        <img class="icon_play_num" src="../../assets/icon_play_num3.png" />
        <span v-if="bagInfo.comments>0">{{bagInfo.comments}}</span>
      </div>
      <!--<button class="flex bottom-btn" style="background-color:#fff;color:#4d4d4d;" @click="showOTA()">激活码</button>-->
      <button class="flex bottom-btn" @click="buyVideo()">购买收听</button>
    </div>

    <!--底部播放按钮-->
    <div v-if="res.isbuy==true" class="btn-video-group1 border-box">
      <div class="video-group1-img" :class="isplay==1?'curr':''" @click="listenTurlClick(index1,'btn')">
        <img class="img video-group1-bj" :src="bagList[index1].logo" />
        <img class="video-group1-start" src="../../assets/icon_play_btn03.png" />
        <img class="video-group1-paused" src="../../assets/icon_play_btn04.png" />
      </div>

      <div class="video-group1-info border-box">
        <div class="video-group1-time border-box clearfix" style="margin-top:.1rem;">
          <div class="video-group1-slider">
            <p ref="slider" id="slider">
              <span :style="{width:currSlider}" ></span>
              <i class="speedDot" :style="{left:currSlider}"></i>
            </p>
          </div>
          <span class="video-group1-allTime">{{bagList[index1].totaltime|initTime}}</span>
        </div>
        <p class="video-group1-tit hide" style="margin-top:.2rem;">{{bagList[index1].spotname}}</p>
        <div class="video-group1-btn">
          <div @click='speedFun' class="fr video-group1-ds ml45">
          <!--<div @click='rewardShowFun' class="fr video-group1-ds ml45" v-if="res.noReward!=1">-->
            <!--<img src="../../assets/icon_play_btn01.png" />-->
            <span>{{speedVideo}}</span>
            <p>倍速</p>
          </div>
          <div @click='nextVideo' class="fr video-group1-next">
            <img src="../../assets/icon_play_btn02.png" />
            <p>下一站</p>
          </div>
        </div>
      </div>
    </div>

    <!--点击屏幕加号按钮弹窗事件-->
    <p @click="videoPlay" class="btn-add none">{{memuText}}</p>
    <div class="alert-box alert-box-con" :class="{'none':menuCurr==0,'curr':menuCurr==1}">
      <p @click="videoPlay" class="mask"></p>
      <div class="btn-add-box" @click="videoPlay">
        <p @click.stop="commentsShow" class="animate animate1">评论</p>
        <p @click.stop="feedbackFun" class="animate animate2">反馈</p>
        <p @click.stop="toUser" class="animate animate3">我的</p>
        <!--<router-link class="animate animate3" @click="MtaH5.clickStat('video_play_menu_user')" :to="{path:'/user',query: {TimeStamp: TimeStamp, appKey: appKeyA}}">我的</router-link>-->
      </div>
    </div>

    <!--图片预览弹窗-->
    <AlertPreviewImg  ref="alertPreviewImg" :previewData="previewData" :currIndex="currIndex" :that="that" :noPlay="noPlay"  @child-PreviewClose="closePreviewImg" v-if="previewShow"></AlertPreviewImg>

    <!--新版本打赏弹窗8-20-->
    <AlertReward :bagInfo="bagInfo" :res="res" :that="that" :dsImgs="res.dsimgs" :class="{'curr':rewardShow==1,'none':rewardShow!=1}" @child-Reward="closeReward"></AlertReward>

    <!--新版本评论弹窗8-21-->
    <AlertComment :bagInfo="bagInfo" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--意见反馈弹窗-->
    <AlertFeedback :class="{'none':feedbackShow==0,'curr':feedbackShow==1}" v-on:child-Feedback="closeFeedback"></AlertFeedback>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--视频播放弹窗-->
    <div class="guide-video" :class="{'none':videoAlert==0}">
      <img class="video-close" v-on:click="pauseVideo()" src="../../assets/red-envelopes-close.png" alt="">
      <div class="guide-video-con" v-on:click="playVideo()">
        <video id="videoPlay" :src="video" :poster="videoimg" @play="play"  preload="auto"
               webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow"></video>
        <img class="guide-play"  src="../../assets/guide-play.png" alt="" v-show="isVideoPlay==false">
      </div>
    </div>

    <!--评论弹幕-->
    <div class="comment-animate-box" :class="{'none':commentsSwiper==0||res.isbuy==true}">
      <swiper v-if='commentList1.length>0' :options="swiperOption" ref="mySwiper">
        <div v-for="(item,index) in commentList1" :key="index" class="swiper-slide comment-animate-con">
          <div class="comment-animate border-box">
            <img class="comment-animate-img" :src="item.rzimg?item.rzimg:item.headimg" alt="">
            <div class="comment-animate-text" :class="{'hide2':item.content.length>20}">
              <span>{{item.name}}：</span>{{item.content}}
            </div>
          </div>
        </div>
      </swiper>
    </div>

    <!--海报弹窗-->
    <AlertPoster  :id="id" :type="'guide'" @close="closePoster" v-if="posterShow==1"></AlertPoster>

    <!--OTA-->
    <AlertOTA  :OTAcode="OTAcode" :bagInfo="bagInfo"  @close="closeOTA" v-if="OTAcodeShow==1"></AlertOTA>

    <!--IOS或Android系统购买成功后提示收藏弹窗-->
    <div class="system-alert" v-show="paySuccess==1">
      <img class="system-img" v-show="system==0" src="../../assets/pay-ios.png" alt="">
      <img class="system-img" v-show="system==1" src="../../assets/pay-android.png" alt="">
      <div class="system-btn" @click="paySuccess=0">知道了</div>
    </div>

    <!--关注公众号弹窗-->
    <Focus :focusRes="focusRes" v-on:alert-Focus="closeFocus()" v-if="focusEwmShow==1"></Focus>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>


    <!--新增语音播放轮播图弹窗-->
    <div class="alert-box alert-swiper" v-show="alertSwiperShow==1">
      <div class="mask"></div>
      <img class="swiper-close" src="../../assets/icon_close2.png" alt="" @click="alertSwiperShow=0">
      <img class="blur-bg" :src="alertSwiperLogo" alt="">
      <div class="swiper-container" id="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in bagList" :key="index" @click="listenTurlClick(item.number)">
            <img class="bg" :src="item.allimg?item.allimg.split(',')[0]:item.logo" alt="">
            <div class="bot-con">
              <img class="icon-btn" :class="(item.number == currIndex && isplay==1)?'curr':''" :src="(item.number == currIndex && isplay==1)?require('../../assets/btn-play1.png'):require('../../assets/btn-play-off1.png')" alt="">
              <p class="hide">{{item.spotname}}</p>
            </div>
          </div>
        </div>
        <div class="swiper-scrollbar"></div>
      </div>
    </div>

  </div>

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { swiper, swiperSlide,Swiper} from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import AlertReward from '../../components/AlertReward'
  import AlertComment from '../../components/AlertComment'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertFeedback from '../../components/AlertFeedback'
  import AlertPoster from '../../components/AlertPoster'
  import AlertOTA from '../../components/AlertOTA'
  import P400 from '../../components/P400'
  import AlertPreviewImg from '../../components/AlertPreviewImg'
  import {getVideoPlay, getBagComment, getZan, uploadUserBrowse, getPopComment, getOTAcode,citySiteFoodZan} from "@/service/getData";
  import {wxGetPosition,wxImgPreview, wxShareme,listenEndOrder, listenTurlVideo,listenVideo,listenVideoBySBY, creatOrder, pushOrder,dragSlide, TimeVideo, downVoice, getWxMini } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import Focus from '../../components/Focus'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)


var fromPath,fullPath;
  export default {
    data(){
      return{
        isback: this.$route.query.isback || '', //是否显示返回按钮
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        id: '', //专辑id
        spotid: '', //景点id
        shopid: '', //景区id
        userInfo: {}, //用户信息
        currRewardShow: false,   //当前语音未弹出过打赏弹窗  true已弹出过打赏弹窗
        res:{
          isReward: false,  //未打赏过  true已打赏过
          noReward: 1 // 0自愿打赏 1关闭打赏 2强制打赏
        },//接口所有数据
        bagInfo:'',//专辑详情
        voice:[],//语音
        bagList:[],//语音列表
        commentList:[],//评论数据
        commentList1:[],//弹幕评论数据
        commentListLen:0,//评论条数
        commentShow:0,//评论弹窗
        rewardShow:0,//打赏弹窗
        bodyHide:0,//页面是否滚动
        memuText:'菜单',//菜单按钮文字
        menuCurr:0,//菜单按钮动画
        feedbackShow:0,//意见反馈弹窗

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        isplay: 0, //当前语音是否播放
        currSlider: 0, //当前进度条
        currTime: 0, //当前播放音频的实时时间
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id

        action: '', //订单推送消息

        TimeStamp: new Date().getTime(),  //获取当前时间
        videoAlert:0,//导游视频弹窗
        hasVideo:0,//导游是否有视频
        video:'',//导游视频
        videoimg:'',//导游视频封面
        isVideoPlay: false,  //视频没有在播放
        commentsSwiper:1,//是否显示弹幕
        swiperOption: {
          initialSlide: 0,
          speed: 100,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
          loop: true,//开启循环模式
          direction: 'vertical',
          observeParents:true,
          observer: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
        },
        alertSwiperShow:0,//新增语音播放轮播图弹窗
        alertSwiperCurr:0,//
        alertSwiperLogo:'',//
        mySwiper: null,
        appKey:'',
        appKeyA: '',
        form: '', //来自哪个页面
        posterShow: 0, //分享海报弹窗
        OTAcode: '', //OTA激活码
        OTAcodeShow: 0, //OTA激活码弹窗
        near:[],
        paySuccess:this.$route.query.paySuccess,//是否支付成功后跳转到该页面
        system:'',//0：ios 1:android
        museumStyle:1,//是否为博物馆样式
        speedIndex:0,//音频播放倍速数组下标
        speedVideo:1.0,//音频播放倍速
        guideInfoState:0,//导游简介状态 0：两行隐藏 1：全部显示
        downloadText:'离线下载',//下载图标提示文字
        downloadTipShow:0,//下载提示是否显示

        focusEwmShow:0,//二维码弹窗0：隐藏   1：显示
        downloadList:[], //存贮的音频数据
        downNum: 0, //下载个数
        downNumF: 0, //失败个数
        downMB: 0, //已下载MB
        focusRes:'',//二维码弹窗数据

        P400: 0, //系统维护中
        previewShow: 0,//图片预览弹窗
        previewData: "", //图片预览弹窗数据
        bagstyle: 0, //0表示新样式  1 表示旧样式

        isWxMini: false, //返回是否是小程序环境
        noBuys: '907,1334,1828,264', //不显示购买量的景区shopid
        volmodal: '', //默认打开图片弹窗
        noPlay: false
      }
    },
    computed: {

    },
    created() {
      this.that = this;
      this.siteid = getStore("siteid") || "";
      this.sregion = getStore("sregion") || "";
      this.id = this.$route.query.id;
      this.spotid = this.$route.query.spotid;
      this.shopid = this.$route.query.shopid;
      if (this.$route.query.volmodal&&this.$route.query.volmodal=='show') {
        this.volmodal = 'show';
      }
      this.form = this.$route.query.form;

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.action = this.$route.query.action;
      let self = this;
      if(this.action == "cancel"){
        this.$confirm({
          title: '提示',
          content: '取消推送授权，退出后将找不到页面入口，需要重新授权吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-play?id='+self.id+'&spotid='+self.spotid+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        }).catch(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-play?id='+self.id+'&spotid='+self.spotid+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        })
      }

      this.$loading.show('数据加载中');
      this.initData();
      this.initComment();

      getWxMini(function(res){
        self.isWxMini =  res;
      });

      this.downApp();
      this.removeDB();

      window.addEventListener("scroll",function(){})
    },
    beforeDestroy(){
      window.removeEventListener("scroll",function(){});
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.bag = {};
      }
    },
    beforeRouteEnter (to, from, next) {
      if(from.path.indexOf('video-play') > -1){
        fromPath = 'video-play';
        fullPath = to.fullPath;
      }
      next();
    },
    beforeRouteLeave(to, from, next) {
      if(this.alertSwiperShow==1 || this.previewShow==1){
        this.alertSwiperShow=0;
        this.previewShow=0;
        next(false);
      }else {
        next();
      }
    },
    mounted(){

      if(fromPath == 'video-play'){
        this.$router.replace({
          path: fullPath
        });
      }
      if(this.form == 'pay'){
        window.addEventListener("popstate", function(e) {
          window.history.go(-6);
        }, false);
        pushHistory();
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, "title", "");
        }
      }

      window.addEventListener('scroll', this.commentOffsetTop)//新增
    },
    methods: {

      async initData(){
        var self = this;
        this.userInfo = getStore("userInfo");

        let res = await getVideoPlay({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id,
          siteid: this.siteid,
          sregion: this.sregion,
          page:1,
          rows:4
        });

        if (res.errcode == "00000"){
          this.$loading.hide();
          this.res = res.data;
          this.bagstyle = res.data.bagstyle || 0;
          this.bagInfo = res.data.bag;
          this.focusRes = res.data.bag;
          this.shopid = res.data.bag.shopid;
          setStore("bagInfo",this.bagInfo);
          this.voice = res.data.voice;
          this.bagList = res.data.voiceList;

          if(res.data.voiceList[0].allimg){
            this.alertSwiperLogo = (res.data.voiceList[0].allimg).split(',')[0]
          }else {
            this.alertSwiperLogo = res.data.voiceList[0].logo;
          }

          if(res.data.bag.liststyle==11){
            this.museumStyle = 1
          }else{
            this.museumStyle = 0
          }

          this.near = res.data.nearshop;

          if(res.data.bag.guidePop == 1 && (res.data.bag.video!=null&&res.data.bag.video!='') && res.data.noPop==1){
            this.videoAlert = 1;
          }else{
            this.videoAlert = 0;
          }

          //新增start
          if(res.data.bag.video!='null'&&res.data.bag.video!=''){
            this.video = res.data.bag.video;
            this.videoimg = res.data.bag.videoimg;
          }
          //新增end

          if(this.$route.query.rewardShow == 1){
            this.rewardShow = 1
          }

          if(this.global.currBag&&this.global.currBag.id == this.id&&this.global.currUrl != ""){
            this.index1 = this.getIndex(this.bagList,this.global.currVoice.spotid);
            this.currIndex = this.index1
            this.isplay = this.global.playing ? 1 : 0;

            this.currTime = this.global.Audio1.currentTime;
            this.currSlider = (this.global.Audio1.currentTime / this.bagList[this.index1].totaltime) * this.global.sliderWidth + "px";

            setTimeout(function(){
              self.scollToComment('video-list-spotid'+self.global.currVoice.spotid,-50);
            },900)

          }else if(this.form == "spot"){
            this.index1 = this.getIndex(this.bagList,this.spotid);
            if(res.data.isPosition == 1){
              setTimeout(function(){
                self.scollToComment('video-list-spotid'+self.spotid,-50);
              },1000);
            }else {
              document.documentElement.scrollTop = document.body.scrollTop = 0;
            }
          }else {
            var currVoice = getStore("currVoice",1) || "";
            if(currVoice && currVoice.spotid != "" && currVoice.spotid != null && currVoice.spotid != undefined ){
              this.index1 = this.getIndex(this.bagList,currVoice.spotid);
            }
          }

          var share = res.data.share;
          let link = '/video-play?id='+ this.id +'&spotid='+ this.spotid +'&shopid='+ this.shopid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(this.spotid){
            link = '/video-play?id='+ this.id +'&spotid='+ this.spotid +'&shopid='+ this.shopid+'&form=spot&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          }
          if(share == null){
            let title = '金牌解说 | ' + this.bagInfo.shopname;
            let desc = '我是'+ this.bagInfo.guidename2 +'，我在“金牌解说”为您讲解'+ this.bagInfo.shopname +'的历史故事';
            let img = this.bagInfo.guideheadimg2 ? this.bagInfo.guideheadimg2 : this.bagInfo.guideheadimg;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.bagInfo.shopname;


          let self = this;
          self.$nextTick(function(){
            setTimeout(function(){
              if(self.global.currUrl == ""){
                self.global.Audio1 = document.getElementById('Audio1');
                self.global.Audio1.src = self.bagList[self.index1].url;
                self.global.Audio1.preload = "auto";
                self.global.Audio1.playbackRate =  self.speedVideo;

                self.global.set_currBag(self.bagInfo);
                self.global.set_currVoice(self.bagList[self.index1]);
                self.global.set_currUrl(self.bagList[self.index1].url);
                self.global.set_playSpeed(self.speedVideo)
              }
              if(self.global.playing){
                setTimeout(function(){
                  TimeVideo(self,self.bagList[self.index1].totaltime);
                },800)
              }
              if(self.res.isbuy==true){
                dragSlide(self);
              }

              if (self.volmodal == 'show') {

                if (self.res.isguide || self.res.isbuy) {
                  self.previewShow = 1;
                  self.bagList[self.index1]['showpro'] = 1;
                  self.previewData = self.bagList[self.index1];
                  self.currIndex = self.index1;

                }

//                self.listenTurlClick(self.index1, self.bagstyle == 1 ? 'spot' : 'alert')
//                for (let item of self.voice) {
//                  for (let ite of item.list) {
//                    if (ite.number === self.currIndex || ite.number === self.index1) {
//                      self.noPlay = true
//
//                      self.listenTurlClick1(ite.number, self.bagstyle == 1 ? 'spot' : 'alert')
//                      break;
//                    }
//                  }
//                }
              }

            },800)
          })
          self.global.set_shopStyle("")


        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
//          this.$router.push({
//            path: `/400?${'appKey=' + this.appKey}`
//          });
        }

        let res1 = await getPopComment({
          TimeStamp: this.TimeStamp,
          page: 1,
          roes: 10,
          bagid: this.id
        });
        if (res1.errcode === "00000"){
          if (res1.data.length > 0) {
            this.commentList1 = res1.data;
          }
        }
      },


      //导游详情显示隐藏切换
      guideInfoStateFun(){
        if(this.guideInfoState == 0){
          this.guideInfoState = 1;
        }else{
          this.guideInfoState = 0;
        }
      },

      //播放倍速
      speedFun(){
        let speedArr = [1.0,1.2,1.5,2.0];
        this.speedIndex++;
        this.speedVideo = speedArr[this.speedIndex];

        if(this.speedIndex == speedArr.length){
          this.speedIndex = 0;
          this.speedVideo = 1.0;
        }
        this.global.Audio1.playbackRate =  this.speedVideo;
        this.global.set_playSpeed(this.speedVideo);
      },

      //博物馆样式和大图样式切换
      museumStyleFun(){
        if(this.museumStyle==0){
          this.museumStyle = 1;
        }else{
          this.museumStyle = 0;
        }
      },
      //博物馆样式点击事件
      museumCurrFun(index){
        var isCurr = document.getElementById('museumLi'+index);
        if(isCurr.classList.contains('curr')){
          isCurr.classList.remove("curr");
        }else{
          isCurr.classList.add("curr");
        }
      },


      //判断手机系统
      downApp() {
        let ua = navigator.userAgent.toLowerCase();
        //Android终端
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    　　   //Ios终端
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            //Ios
          this.system = 0;
        } else if (/(Android)/i.test(navigator.userAgent)) {
            //Android终端
          this.system = 1;
        }
      },


      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      async initComment(){
        let res = await getBagComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: 1,
          rows: 5,
          bagid: this.id
        });

        if (res.errcode === "00000"){
          if (res.data.root.length > 0) {
            this.commentList = res.data.root;
            this.commentListLen = res.data.total;
          }
        }
      },

      //页面滑动到指定标签id位置
      scollToComment(elmid,top){
        MtaH5.clickStat("video_play_icon_comment");
        let self = this;
        self.$nextTick(function() {
          var dom = document.getElementById(elmid);
          if(dom && dom != null){
            if(top){
              window.scrollTo(0,Number(self.offSet(dom)+top));
            }else {
              window.scrollTo(0,self.offSet(dom));
            }
          }
        });
        self.commentsSwiper = 0;//新增判断是否显示评论弹幕
      },

      offSet(curEle){
        var totalTop = null;
        var par = curEle.offsetParent;
        //首先把自己本身的相加
        totalTop += curEle.offsetTop;
        //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
        while (par){
          //把父级参照物的偏移相加
          totalTop += par.offsetTop;
          par = par.offsetParent;
        }
        return totalTop;
      },

      //打赏弹窗显示隐藏
      rewardShowFun(){
        MtaH5.clickStat("video_play_reward");
        this.rewardShow = 1;
      },
      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.initComment();
        }
      },

      //图片预览弹窗隐藏
    closePreviewImg :function(msg){
        this.previewShow = msg.previewShow;
        this.previewData = "";
      },

      //打赏弹窗隐藏
      closeReward :function(msg){
        this.rewardShow = msg.rewardShow;
        if(msg.success){
//          this.initData();
          this.bagInfo.dsnum++;
        }
      },
      //意见反馈弹窗隐藏
      closeFeedback :function(feedbackClose){
        this.feedbackShow = feedbackClose
      },
      //菜单按钮动画
      videoPlay(){
        if(this.menuCurr==1){
          this.menuCurr=0
          this.memuText='菜单'
        }else{
          this.menuCurr=1
          this.memuText='关闭'
        }
      },

      //显示与隐藏意见反馈
      feedbackFun(){
        MtaH5.clickStat("video_play_menu_feedback");
        if(this.feedbackShow==0){
          this.feedbackShow=1
          this.menuCurr = 0
          this.memuText = '菜单'
        }else{
          this.feedbackShow=0
          this.menuCurr = 1
          this.memuText = '关闭'
        }
      },

      //评论弹窗显示隐藏
      commentsShow(){
        MtaH5.clickStat("video_play_menu_comment");
        if(!this.res.isbuy){
          this.menuCurr = 0
          this.memuText = '菜单'
          this.$toast('请先购买')
        }else{
          //this.bodyHide = 1
          this.menuCurr = 0
          this.memuText = '菜单'
          this.commentShow = 1
        }
      },

      //跳转到个人中心页面
      toUser(){
        MtaH5.clickStat('video_play_menu_user')
        this.$router.push({
          path: `/user?${'TimeStamp='+(this.TimeStamp)+'&appKey='+(this.appKey)}`
        });
      },

      //用户评论点赞
      async uploadZan(index){
        let res = await getZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          commentid: this.commentList[index].id
        });
        if(res.errcode == "00000"){
          this.commentList[index].totalZan++;
          this.commentList[index].iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },

      //专辑点赞
      async videoPlayZan(){
        let res = await citySiteFoodZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id
        });
        if(res.errcode == "00000"){
          this.bagInfo.zancounts++;
          this.res.iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },



      //点击一下曲
      nextVideo(){
        let currIndex = (this.currIndex == this.bagList.length -1) ? 0 : (parseInt(this.currIndex) + 1);
        listenVideo(this,currIndex);
        if(this.mySwiper){
          this.mySwiper.slideTo(currIndex, 1000, false);
        }
      },
      listenTurlClick1(ind, btn) {
    console.log(ind, btn)
        if(this.id=='3064'||this.id=='3592'||this.id=='3591'||this.id =='3590'||this.id =='3598'){
          if((this.id=='3064'&&ind<40) || ((this.id=='3592'||this.id=='3591'||this.id =='3590'||this.id =='3598')&&ind>19) || this.res.isguide || this.res.isbuy){
            if(btn == "spot"){
              this.previewShow = 1;
              this.previewData = this.bagList[ind];
            }
            if(btn == "alert"){
              var self = this;
              self.alertSwiperShow = 1;
              self.mySwiper = new Swiper("#mySwiper", {
                initialSlide: ind,
                slidesPerView: 1.6,
                spaceBetween: 20,
                centeredSlides: true,
                watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
                loop: false,//开启循环模式
                observeParents:true,
                observer: true,
                autoplay: false,
                scrollbar: {
                  el: ".alert-swiper .swiper-scrollbar",
                  hide: false
                },
                on:{
                  slideChangeTransitionEnd: function(){
                    self.alertSwiperCurr = this.activeIndex-1;
                    if((this.activeIndex-1)>=0){
//                      self.alertSwiperLogo = self.bagList[this.activeIndex-1].logo;

                      if(self.bagList[this.activeIndex-1].allimg){
                        self.alertSwiperLogo = (self.bagList[this.activeIndex-1].allimg).split(',')[0]
                      }else {
                        self.alertSwiperLogo = self.bagList[this.activeIndex-1].logo;
                      }
                    }
                  },
                }
              });
              listenVideo(self,ind);
            }
            if(!((btn == "spot" || btn == "alert") && ind  == this.global.currIndex && this.global.playing == 1)){
              listenVideo(this,ind);
            }
          }else {
            this.$toast('试听时间结束，请先购买');
            this.bag = this.bagInfo;
            if(!this.global.Audio1.paused) this.global.Audio1.pause();
            this.isplay = 0;
            if(this.global.videoTimer != null){
              clearInterval(this.global.videoTimer);
            }

            this.global.set_playing(false)
            this.global.set_playerShow(false)
          }
        }else {
          if (this.res.isguide || this.res.isbuy) {
            if(btn == "spot"){
              this.previewShow = 1;
              this.bagList[ind]['showpro'] = 1;
              this.previewData = this.bagList[ind];
            }
            if(btn == "alert"){
              var self = this;
              self.alertSwiperShow = 1;
              self.mySwiper = new Swiper("#mySwiper", {
                initialSlide: ind,
                slidesPerView: 1.6,
                spaceBetween: 20,
                centeredSlides: true,
                watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
                loop: false,//开启循环模式
                observeParents:true,
                observer: true,
                autoplay: false,
                scrollbar: {
                  el: ".alert-swiper .swiper-scrollbar",
                  hide: false
                },
                on:{
                  slideChangeTransitionEnd: function(){
                    self.alertSwiperCurr = this.activeIndex-1;
                    if((this.activeIndex-1)>=0){
                      if(self.bagList[this.activeIndex-1].allimg){
                        self.alertSwiperLogo = (self.bagList[this.activeIndex-1].allimg).split(',')[0]
                      }else {
                        self.alertSwiperLogo = self.bagList[this.activeIndex-1].logo;
                      }
                    }
                  },
                }
              });
              listenVideo(self,ind);
            }

            if(!((btn == "spot" || btn == "alert") && ind == this.global.currIndex && this.global.playing == 1)){
              listenVideoBySBY(this,ind)
            }

          }else {
            MtaH5.clickStat('jingqujingdiana-3',{'2listen':'true'});//景区景点进入专辑详情》1试听》购买》支付
            MtaH5.clickStat('jingqujingdiana-4',{'2listen':'true'});//景区景点进入专辑详情》1试听》弹窗购买》支付
            listenTurlVideo(this,ind);
          }
        }
      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind, btn) {
        if(this.id=='3064'||this.id=='3592'||this.id=='3591'||this.id =='3590'||this.id =='3598'){
          if((this.id=='3064'&&ind<40) || ((this.id=='3592'||this.id=='3591'||this.id =='3590'||this.id =='3598')&&ind>19) || this.res.isguide || this.res.isbuy){
            if(btn == "spot"){
              this.previewShow = 1;
              this.previewData = this.bagList[ind];
            }
            if(btn == "alert"){
              var self = this;
              self.alertSwiperShow = 1;
              self.mySwiper = new Swiper("#mySwiper", {
                initialSlide: ind,
                slidesPerView: 1.6,
                spaceBetween: 20,
                centeredSlides: true,
                watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
                loop: false,//开启循环模式
                observeParents:true,
                observer: true,
                autoplay: false,
                scrollbar: {
                  el: ".alert-swiper .swiper-scrollbar",
                  hide: false
                },
                on:{
                  slideChangeTransitionEnd: function(){
                    self.alertSwiperCurr = this.activeIndex-1;
                    if((this.activeIndex-1)>=0){
//                      self.alertSwiperLogo = self.bagList[this.activeIndex-1].logo;

                      if(self.bagList[this.activeIndex-1].allimg){
                        self.alertSwiperLogo = (self.bagList[this.activeIndex-1].allimg).split(',')[0]
                      }else {
                        self.alertSwiperLogo = self.bagList[this.activeIndex-1].logo;
                      }
                    }
                  },
                }
              });
              listenVideo(self,ind);
            }
            if(!((btn == "spot" || btn == "alert") && ind  == this.global.currIndex && this.global.playing == 1)){
              listenVideo(this,ind);
            }
          }else {
            this.$toast('试听时间结束，请先购买');
            this.bag = this.bagInfo;
            if(!this.global.Audio1.paused) this.global.Audio1.pause();
            this.isplay = 0;
            if(this.global.videoTimer != null){
              clearInterval(this.global.videoTimer);
            }

            this.global.set_playing(false)
            this.global.set_playerShow(false)
          }
        }else {
          if (this.res.isguide || this.res.isbuy) {
            if(btn == "spot"){
              this.previewShow = 1;
              this.previewData = this.bagList[ind];
            }

            if(btn == "alert"){
              var self = this;
              self.alertSwiperShow = 1;
              self.mySwiper = new Swiper("#mySwiper", {
                initialSlide: ind,
                slidesPerView: 1.6,
                spaceBetween: 20,
                centeredSlides: true,
                watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
                loop: false,//开启循环模式
                observeParents:true,
                observer: true,
                autoplay: false,
                scrollbar: {
                  el: ".alert-swiper .swiper-scrollbar",
                  hide: false
                },
                on:{
                  slideChangeTransitionEnd: function(){
                    self.alertSwiperCurr = this.activeIndex-1;
                    if((this.activeIndex-1)>=0){
                      if(self.bagList[this.activeIndex-1].allimg){
                        self.alertSwiperLogo = (self.bagList[this.activeIndex-1].allimg).split(',')[0]
                      }else {
                        self.alertSwiperLogo = self.bagList[this.activeIndex-1].logo;
                      }
                    }
                  },
                }
              });
              listenVideo(self,ind);
            }

            if(!((btn == "spot" || btn == "alert") && ind == this.global.currIndex && this.global.playing == 1)){
              listenVideo(this, ind);
            }

          }else {
            MtaH5.clickStat('jingqujingdiana-3',{'2listen':'true'});//景区景点进入专辑详情》1试听》购买》支付
            MtaH5.clickStat('jingqujingdiana-4',{'2listen':'true'});//景区景点进入专辑详情》1试听》弹窗购买》支付
            listenTurlVideo(this,ind);
          }
        }
      },

      //点击购买，调用下订单公用方法
      buyVideo(){
        MtaH5.clickStat("video_play_buy");
        MtaH5.clickStat('jingqujingdiana-2',{'2buy':'true'});//景区景点进入专辑详情》1点击购买》支付
        MtaH5.clickStat('jingqujingdiana-3',{'3buy':'true'});//景区景点进入专辑详情》试听》1购买》支付
        let self = this;
        setStore("source", {"source": "video"})
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagInfo.id+'&cid='+self.couponid+'&shopid='+self.bagInfo.shopid+'&bagtype=0'+'&appKey='+(self.appKey)}`
        });

//        creatOrder(this,this.bagInfo,"",function(data){
//          if(data){
//            self.res.isbuy = true;
//            pushOrder('dist/index.htmlJH/video-play?id='+self.bagInfo.id+'ANDspotid='+self.bagInfo.spotid+'ANDshopid='+self.bagInfo.shopid + 'ANDTimeStamp='+ self.TimeStamp + 'ANDappKey='+ self.appKey);
//          }
//        })
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          this.res.isbuy = true;
        }
      },

      //拿到数组中指定spotid的下标
      getIndex(arr,spotid){
        let result;
        if(arr.find(function(x) {return x.spotid == spotid;}) != undefined) {
          arr.find(function(x,i) {
            if(x.spotid == spotid){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },

      //跳转到导游详情页
      goGuideInfo(id){
        if(this.res.guide2info==1){
            MtaH5.clickStat("video_play_person");
            this.$router.push({
                path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
            });
        }

      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },

      //新增视频播放
      playVideo(){
        var vdo = document.getElementById("videoPlay");
        if (vdo.paused) {
          vdo.play();
          this.isVideoPlay = true;
          if(this.isplay != 0){
            this.Audio.pause();
            this.isplay = 0;
            if(this.videoTimer != null){
              clearInterval(this.videoTimer);
            }
          }
        } else {
          vdo.pause();
          this.isVideoPlay = false;
        }
      },
      pauseVideo(){
        var vdo = document.getElementById("videoPlay");
        vdo.pause();
        this.isVideoPlay = false;
        this.videoAlert = 0;
      },
      btnVideo(){
        this.videoAlert = 1;
      },
      play(){
        var vdo = document.getElementById("videoPlay");
        if(this.isplay != 0){
          this.Audio.pause();
          this.isplay = 0;
          if(this.videoTimer != null){
            clearInterval(this.videoTimer);
          }
        }
      },

      commentOffsetTop () { //新增评论距离浏览器顶部的距离
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var offsetTop = document.querySelector('.comments-list-top').offsetTop;
        if(offsetTop-scrollTop<=50&&this.voice.length>0){
          this.commentsSwiper = 0;
        }
      },

      //显示分享海报弹窗
      showPoster(){
        MtaH5.clickStat('poster_share',{'videoplay':'true'});
        this.posterShow = 1;
      },

      //关闭分享海报弹窗
      closePoster(msg){
        this.posterShow = msg;
      },

      //关闭OTA弹窗
      closeOTA(msg){
        this.OTAcodeShow = 0;
        if(msg.isbuy){
          this.res.isbuy = true;
        }
      },

      //显示OTA弹窗
      async showOTA(){
        let res = await getOTAcode();
        if (res.errcode === "00000"){
          this.OTAcode = res.data
        }
        this.OTAcodeShow = 1
      },

      toViewDetail(id,shopType){
        MtaH5.clickStat('zhuanjixiangqin',{'start':'true'});//专辑详情页点击1推荐景区》购买》支付
        MtaH5.clickStat('video_play_tj');
        if(shopType == "buddhism"){
          this.$router.push({
            path: `/view-detail-sm?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }else {
          this.$router.push({
            path: `/view-detail?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }
      },

      //跳转到地图页面
      toGiudeMap(){
        var ind = this.currIndex&&this.currIndex!=-1?this.currIndex:0;
        this.$router.push({
          path: `/map?${'formGuide=1&sort=0&bagid='+ this.id + '&spotid='+ this.bagList[ind].spotid +'&shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //返回上一页/返回景区首页
      back(){
        if(this.isback==1){
          MtaH5.clickStat("video_back");//专辑详情页面点击返回上一页
          this.$router.go(-1);//返回上一层
        }else {
          this.$router.push({
            path: `/view-detail?${'shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }
      },

      //下载接口
      async downAllVoice(){
        let res = await downVoice({
          TimeStamp: this.TimeStamp,
          bagid: this.id
        });
      },

      //点击下载
      download(){
        let self = this;
        if(!this.res.isbuy){
          this.$toast('请先购买专辑');
          return;
        }
        if( self.downloadText == '离线下载' ||  self.downloadText == '重新下载'){
          this.$confirm({
            title: '提前下载',
            content: '<div style="color: #333;">网页关闭后需重新下载<br><span style="color:#999;">（约'+ self.res.totalSize +'MB）是否开始？</span></div>',
            component: wxConfirm
          }).then(function(res){
            if (res == 'success') {
              self.downloadText = '下载中';
              self.downloadTipShow = 1;

//              for(var i =0;i<self.bagList.length;i++){  //循环遍历调用downloadFile方法
//                var url = self.bagList[i].url;
//                self.downloadFile(url,i);
//              }

              downVoice(self.id,function(res){
                self.downMB = (res.loaded/1024/1024).toFixed(2)
              },function(res){
                if(res.errcode == "00000"){
                  self.downloadList = res.data
                  self.createDB(self.downloadList);
                  self.$router.push({
                    path: `/download-list?${'id='+self.id+'&shopid='+self.shopid+'&TimeStamp='+self.TimeStamp+'&appKey='+self.appKey}`
                  });
                }else {
                  self.$toast(res.errmsg)
                  self.downloadText = '重新下载';
                  self.downloadList = [];
                }

              });
            }

          }).catch(function(res){
            if (res == 'success') {

            }
          })
        }
      },

      downloadFile(url,i){
        let self = this;

        var xhr = new XMLHttpRequest();
        var fileReader = new FileReader();
        xhr.open("GET", url, true);
        xhr.responseType = 'blob';
//        xhr.setRequestHeader('Cache-Control', 'no-cache');
        xhr.addEventListener("load", function () {
          if (xhr.status === 200) {
            var blob = this.response;
            fileReader.onload = function (evt) {
              var result = evt.target.result;
              var json = {};
              json.mid = self.bagList[i].id;
              json.name = self.bagList[i].spotname;
              json.url = result;
              self.downloadList.push(json);
              self.downNum++;
              if((self.downNumF+self.downNum)>=self.bagList.length){
                self.downloadText = '重新下载';

                self.createDB(self.downloadList);
                self.$router.push({
                  path: `/download-list?${'id='+self.id+'&shopid='+self.shopid+'&TimeStamp='+self.TimeStamp+'&appKey='+self.appKey}`
                });
                self.downloadList = [];
                self.downNum = 0;
                self.downNumF = 0;
              }
            };
            fileReader.readAsDataURL(blob);
          }
        }, false);
        xhr.addEventListener("error", function () {
          self.downNumF++;
          if((self.downNumF+self.downNum)>=self.bagList.length){
            self.downloadText = '重新下载';

            self.createDB(self.downloadList);
            self.$router.push({
              path: `/download-list?${'id='+self.id+'&shopid='+self.shopid+'&TimeStamp='+self.TimeStamp+'&appKey='+self.appKey}`
            });
            self.downloadList = [];
            self.downNum = 0;
            self.downNumF = 0;
          }
        }, false);
        // 发送异步请求
        xhr.send();

      },

      /***本地存储数据库的方法***/
      createDB(mdata){
        let self = this;
        var db;
        //打开数据库
        var request = window.indexedDB.open("musicDB");
        request.onerror = function (e) {
          console.log(e);
        };
        request.onsuccess = function (e) {
          console.log(e);
          db = e.target.result; // 获取数据库对象
          console.log("数据库版本"+db.version);

          db.onerror = function(event) {
            console.log("数据库错误: " + event.target.errorCode);
          };

          var transaction = db.transaction(['musicStore'], 'readwrite');
          var musicStore = transaction.objectStore('musicStore');
          for(var i=0;i<mdata.length;i++){
            musicStore.put(mdata[i]);
          }
        };

        request.onupgradeneeded = function (e) {
          db = e.target.result; // 获取数据库对象
          if (!db.objectStoreNames.contains("musicStore")) {
            var objectStore = db.createObjectStore("musicStore", {autoIncrement: true});
          }
        }
      },

      removeDB(){
        let self = this;
        var db = null;
        var request = window.indexedDB.open("musicDB");
        request.onerror = function (e) {
          console.log(e);
        };
        request.onsuccess = function (e) {
          db = e.target.result; // 获取数据库对象

          var transaction = db.transaction(['musicStore'], 'readwrite');
          var musicStore = transaction.objectStore('musicStore');
          musicStore.clear();
        };

        request.onupgradeneeded = function (e) {
          db = e.target.result; // 获取数据库对象
          if (!db.objectStoreNames.contains("musicStore")) {
            var objectStore = db.createObjectStore("musicStore", {autoIncrement: true});
          }
        }
      },

      //关注公众号
      focusFun(){
        MtaH5.clickStat("focus");//关注公众号
        this.focusEwmShow = 1;
      },

      //公众号弹窗关闭
      closeFocus(){
        this.focusEwmShow = 0;
      },


    //swiper语音收听弹窗隐藏
    closeSwiperAlert :function(){
      this.alertSwiperShow = 0;
      clearInterval(this.videoTimer);
      this.currIndex = -1;
      this.bagList[this.index1].isplay = 0;
    },

    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          listenEndOrder(this,this.index1,this.bagInfo,true);
        }
      }
    },
    components: {
      AlertReward,
      AlertComment,
      AlertListenEnd,
      AlertFeedback,
      AlertPoster,
      wxConfirm,
      AlertOTA,
      Focus,
      P400,
      AlertPreviewImg
    },
    //格式化数据
    filters: {
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      },
      initNumber1: function (num) { //重置购买数据
        if(num>=1000){
          num = '1000+'
        }
        return num;
      }
    },

    destroyed () {//新增离开该页面需要移除监听评论距离顶部距离属性
      window.removeEventListener('scroll', this.commentOffsetTop)
    },
  }

</script>

<style scoped>
  @import '../../style/alert.css';
  * { touch-action: pan-y; }
  .page{padding-bottom:1.45rem; background-color: #fff; min-height: 98vh; }
  /*顶部背景图*/
  .top-bg{position:relative;width: 100%;height: 2.14rem;}
  .video_play_bg{width: 100%;height: 100%;object-fit: cover; }

  /*头部导游信息*/
  .list{ position: relative;background: #fff;margin: -1.3rem .27rem 0;border-radius: .1rem;padding: .44rem .28rem .2rem;box-shadow: 0 0 0.25rem #f1f1f1;}
  .list.down{margin-top: -.9rem;}
  .list-map-icon{position: fixed;bottom: 1.7rem;right:.28rem;width: .78rem;height: auto; z-index: 2; }
  .list-box{width:100%;font-weight:bold;}
  .list-img{ float: left;position: relative;width: 2.14rem;height: 2.6rem;margin-top: -.92rem;}
  .list-img img.icon-tx{display:block;width:100%;height:100%;border-radius: .13rem;background-color: #fff;}
  .list-img img.video{position:absolute;bottom:0;right:0;width:.81rem;height:.46rem;border-radius:0 0 .13rem 0; }
  .list-info{position:relative;padding-left: .28rem;padding-right: 0; }
  .list-group{font-size:.32rem;color:#555;}
  .list-name{margin-top: .24rem;font-size: .22rem;color: #b1b1b1;}
  .star-box-new{height:.42rem;margin-top: .08rem;}
  .star-box-new img{float:left;width: auto;height: .25rem;margin-right: .09rem;margin-top: .085rem;}
  .star-box-new span{float: left;margin-left:.13rem;font: .24rem/.42rem "Microsoft YaHei";color: #c6c6c6;}
  .list-box-info{margin-top:.25rem;font:.22rem/.4rem "Microsoft YaHei";color: #3d3d3d;}
  .list-time-num {height:.4rem; line-height:.44rem; margin-top: .45rem; }
  .list-time-num>p{display: inline-block;line-height:.44rem;margin-right:.2rem;font-size: .24rem; color: #666;}
  .list-time-num img{float:left;width:auto;height:.4rem;margin-right: .08rem;margin-top: .01rem}
  .list-share{ position:absolute;bottom: .2rem;right: .28rem;z-index:7; width: .41rem; height: .72rem; }
  .list-share.dowm{ bottom: 0; top: .24rem; }
  .list-share img{ width: 100%; height: auto; }
  .list-zan{color: #666;font-size: .24rem;}
  .list-zan.curr{color: #ffc53f;}
  .list-zan img{float:left;width: auto;height: .36rem;margin-right: .1rem;}

  /*打赏*/
  .ds-box{height: .9rem;margin: .2rem .28rem 0;padding-left:.22rem;padding-right:.22rem;border-radius: .5rem;box-shadow: 0 0 0.25rem #f1f1f1;}
  .ds-box-img{float: left;width: .6rem;height: .6rem;margin-left:-.06rem;margin-top:.15rem;border-radius: 50%;object-fit: cover;}
  .ds-box-img:first-child{margin-left: 0;}
  .ds-box-num{float: left;margin-left: .22rem;font: .24rem/.9rem "Microsoft YaHei";color: #666;}
  .ds-box-btn{width: .7rem;height: .7rem;text-align: center;margin-top: .1rem;font: .22rem/.7rem "Microsoft YaHei";color: #fff;border-radius: 50%;background: #ffc53f;}

  /*新增标题样式*/
  .list-tit-new{position:relative;padding: .24rem .18rem .4rem;line-height: .4rem;font: bold .32rem/.4rem "Microsoft YaHei";color: #333;}
  .list-tit-new span{float: left;}
  .list-tit-new span:nth-of-type(2){ display: inline-block;height: .32rem;padding: 0 .08rem;margin-left: .08rem;margin-top: .04rem;border-radius: .3rem;background: #39affa;font: .18rem/.32rem "Microsoft YaHei";color: #fefefe;}
  .list-tit-new .museum_icon{position: absolute;top:50%;right:.28rem;width: auto;height: .65rem;margin-top: -.3rem;}

  /*普通列表样式*/
  .video-list{position:relative;width:100%;padding:.30rem .20rem;border-bottom:.01rem solid #f0f0f0;}
  .icon_gps{position:absolute;left:-.12rem;top:50%;width:.26rem;height:.24rem;transform:translateY(-40%);}
  .list-title{position:relative;font-size:.28rem;color:#faaf39;padding-left:.20rem;}
  .video-list-info{float:left;width:50%;margin-top:.30rem;}
  .video-list-con{position:relative;display:block;width:3.20rem;height:3.20rem;margin:0 auto;background:url(https://jpjs.geeker.com.cn/frame/images/default_bg.png) no-repeat 50% ;overflow: hidden;}
  .video-list-con img{width:100%;height:100%;background: none;}
  .video-list-con .video-mask{ position: absolute;left: 0; right: 0;top: 0;height: 2.6rem;background:rgba(0,0,0,.4);pointer-events: none; }
  .video-list-con .video-icon{ position: absolute;left: 50%; top: .9rem; margin-left: -.4rem; width: .8rem; height: .8rem;pointer-events: none; }
  .video-list-con.curr{-webkit-box-shadow: 0 0 .2rem #fec200;box-shadow: 0 0 .2rem #fec200; border: 2px solid #fec200;}
  .video-bottom{position:absolute;bottom:0;width:100%;height:.60rem;line-height:.60rem;background:rgba(0,0,0,.4);}
  .video-bottom img{float:right;display:inline-block;width:.60rem;height:.60rem;}
  .video-bottom span{float:left;margin-left:.15rem;font-size:.20rem;color:#fff;}
  .video-bottom span.video-line-white{display:none;width:30%;height:.02rem;margin-top:.29rem;margin-left:.05rem; background:#fff;}
  .video-list-info .spot-name{display:block;width:3.20rem;line-height:.32rem;margin:.10rem auto 0;font-size:.28rem;color:#000;}
  .video-list-info .spot-name.curr{color:#faaf39;}
  .video-bottom .spot-play{float:left;width:.21rem;height:.22rem;margin-top:.19rem;margin-left:.20rem;background: url(../../assets/icon_listen01.png);background-size: 100% 100%;}
  .video-bottom .spot-play.curr{background: url(../../assets/icon_listen01.gif);background-size: 100% 100%;}
  .bottom-btn-box{position:fixed;left:0;bottom:0;width:100%;height:1.14rem;background: #fff;z-index:1;box-shadow:0 0 .05rem #ddd;}
  .bottom-btn{ position: relative; display: block; height:1.14rem;line-height:1.14rem;color:#fff;background: #faaf39;z-index:1;text-align:center;font-size:.36rem;letter-spacing:.04rem;}
  .video-listen{position:relative;width:1.50rem;height:1.14rem;}
  .video-listen span{position:absolute;top:.22rem;left:initial;right:16%;padding:.03rem .07rem;font-size:.18rem;color:#fff;background:#f96900;border-radius:.10rem;min-width:.24rem;text-align:center;}
  .btn-video-box.box1 .video-listen{position:absolute;left:0;top:50%;width:1.20rem;height:.45rem;-webkit-transform:translateY(-50%);transform:translateY(-50%);}
  .btn-video-box.box1 .video-listen span{position:absolute;top:-.20rem;left:initial;right:.12rem;padding:.03rem .10rem;font-size:.20rem;color:#fff;background:#faaf39;border-radius:.10rem;}
  .icon_play_num{position:absolute;top:50%;left:50%;width:.54rem;height:.50rem;margin:0 auto;transform:translate(-50%,-50%);}
  .video-see{position: absolute;right: -.34rem; top: .05rem; width: 1.2rem;height: .4rem;line-height: .4rem;font-size:.22rem;color:#fff;background-color: #f96900;text-align: center;transform: rotate(45deg);}

  /*博物馆列表样式*/
  .video-list.museum{height:1.14rem;padding: 0 .1rem .14rem;border-bottom:none;overflow: hidden;}
  .video-list.museum.curr{height: auto;}
  .video-list.museum .list-title{height: 1rem;line-height:1rem;font-size: .32rem;color: #242424;border-radius: .12rem;box-shadow: 0 0 .25rem #f4f4f4;}
  .video-list.museum .icon_sj{width: .26rem;height: .13rem;margin-top: .435rem;margin-right: .37rem;}
  .video-list.museum.curr .icon_sj{-webkit-transform: rotate(-180deg);transform: rotate(-180deg);}
  .video-list.museum .museum-box{margin:0 .28rem;padding-bottom: .12rem;background: #fbfbfb;border-radius: .14rem;}
  .video-list.museum .video-list-info{position:relative;width: 33.33%;}
  .video-list.museum .video-list-info:nth-of-type(6n),.video-list.museum .video-list-info:nth-of-type(6n-1),.video-list.museum .video-list-info:nth-of-type(6n-2){float: right;}
  .video-list.museum .video-list-con{width: 1.18rem;height: 1.18rem;border-radius:50%;}
  .video-list.museum .video-list-con img.img{position:relative;z-index:1;width:100%;height: 100%;border-radius:50%;object-fit: cover;}
  .video-list.museum .video-list-con .left-line{position: absolute;left: 50%;top:50%;width:33vw;margin-top:-.02rem;border-top:.04rem dotted #b8b8b8;opacity: .5;}
  .video-list.museum .video-list-info:nth-of-type(6n-3) .left-line, .video-list.museum .video-list-info:nth-of-type(6n-2) .left-line, .video-list.museum .video-list-info:last-child .left-line{display: none;}
  .video-list.museum .video-list-info:nth-of-type(6n-1) .left-line{display: block;}
  .video-list.museum .vertical-line{display:none;position: absolute;left: 50%;top:50%;height:33vw;margin-left:-.02rem;border-left:.04rem dotted #b8b8b8;opacity: .5;}
  .video-list.museum .video-list-info:nth-of-type(3n+3) .vertical-line{display: block;}
  .video-list.museum .video-list-info:last-child .vertical-line{display: none;}
  .video-list.museum .icon-play{position: absolute;z-index: 1;top:50%;left: 50%;width:auto;height:.32rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-list.museum .spot-name{position:relative;width: 100%;z-index:1;padding: 0 .12rem;color: #383838;font-size: .24rem;}
  .video-list.museum .buy-state{position: absolute;z-index: 1;top:-.04rem;right:-.06rem;width: .45rem;height: .45rem;line-height: .45rem;text-align: center;font-size: .16rem;color: #ff7010;background: #fff;border-radius: 50%;box-shadow: 0 0 .25rem #e5e5e5;}
  .video-list.museum .buy-state img{position: absolute;top:50%;left:50%;width: .17rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}

  /*新增底部评论详情列表*/
  .comments-list{width:100%;padding:.36rem 0  .16rem .24rem; margin-bottom: 0; }
  .comments-list-top{width:100%;height:.88rem;padding:0 .22rem;margin-top: .4rem;border-bottom:1px solid #F0F0F0;}
  .comments-list-top .fl{font:bold .32rem/.88rem "Microsoft YaHei";color:#333;}
  .comments-list-top .fr{font:.28rem/.88rem "Microsoft YaHei";color:#666;}
  .comments-list-top .fr img{float:right;width:.29rem;height:.32rem;margin:.28rem 0 0 .16rem;}
  .comments-list .bottom-box{position:relative;width:100%;height:.88rem;background:#fff;}
  .select-more{height:.88rem;line-height:.88rem;font-size:.30rem;color:#faaf39;text-align:center;background: none;}

  /*底部播放按钮组*/
  .btn-video-group1{ position: fixed; left: .08rem; right: .08rem; bottom: 0; z-index: 8; height: 1.42rem; padding: .14rem .33rem .17rem 1.44rem; box-shadow: 0 0 .10rem .05rem #ddd; background: #fff; border-radius: .10rem;  }
  .video-group1-img{ position: absolute; left: .18rem; top: .15rem; width: 1.10rem; height: 1.10rem; }
  .video-group1-bj{ width: 100%; height: 100%; }
  .video-group1-start,.video-group1-paused{ position: absolute; left: .19rem; top: .19rem; z-index: 1; width: .72rem; height: .72rem; }
  .video-group1-paused{ display: none; }
  .video-group1-img.curr .video-group1-start{ display: none; }
  .video-group1-img.curr .video-group1-paused{ display: block; }
  .video-group1-info{ position: relative; width: 100%; height: 1.10rem; padding-right: 2.60rem; }
  .video-group1-tit{ font: normal .30rem/.40rem "Microsoft YaHei"; color: #575757; }
  .video-group1-time{ position: relative; padding-right: .76rem; margin-top: .38rem; height: .30rem; }
  .video-group1-slider{ position: relative; width: 84%; margin: 0 auto; padding-top: .12rem; }
  .video-group1-slider p{ position: relative; width: 100%; height: .05rem; background-color: #eaebec; border-radius: .05rem; }
  .video-group1-slider p span{ position: absolute; left: 0; top: 0; z-index: 1; width: 100%; height: .05rem; background-color: #faaf39; border-radius: .05rem; }
  .video-group1-slider p i{position: absolute; left: 0; top: -.29rem; z-index: 1; margin-left: -.45rem; width: .9rem; height: .6rem; background: url(../../assets/icon_play_btn12.png) no-repeat; background-size: 100% 100%; }
  .video-group1-allTime{ position: absolute; right: 0; top: 0; z-index: 1; height: .30rem; font: .22rem/.30rem "Microsoft YaHei"; color: #535861; }
  .video-group1-btn{ position: absolute; right: 0; top: 0; width: 2.60rem; height: 1.10rem; }
  .video-group1-btn div{ display: inline-block; width: .78rem; height: 1.10rem; text-align: center; }
  .video-group1-btn div img{ display: block; width: .78rem; height: .78rem; }
  .video-group1-btn div p{ display: block; width: .78rem; font: .20rem/.36rem "Microsoft YaHei"; color: #ffba00; }
  .video-group1-ds span{display: block; width: .78rem; height: .78rem;font:bold .26rem/.78rem "Microsoft YaHei";color: #fff;background: #ffba00; border-radius: 50%;text-align: center;}

  /*视频弹窗*/
  .guide-video{position: fixed;top:0;left: 0;width: 100%;height: 100%;background:rgba(0,0,0,.56);z-index: 99;text-align: center;}
  .guide-video-con{position: absolute;top:45%;left: 50%;width: 90%;height: 80%;border-radius: .12rem;background: none;transform: translate(-50%,-50%);overflow: hidden;}
  .guide-play{position: absolute;top:50%;left: 50%;width: 1.08rem;height: 1.08rem;transform: translate(-50%,-50%);z-index: 9;}
  .guide-play.curr{display: block;}
  .guide-video-con video{display: block;height:100%; max-width: 100%; margin: 0 auto;border-radius: .12rem;}
  .video-close{position: absolute;left: 50%;width: .6rem;height: .6rem;margin-left: -.3rem;bottom: 5%;}

  /*评论弹幕*/
  .comment-animate-box{position: fixed;z-index: 1;bottom:1.2rem;left:.24rem;max-width: 79.6%;height: .88rem;}
  .swiper-container{height: 100%;}
  .comment-animate{float: left;position:relative;display: inline-block;height:.88rem;padding:.1rem .35rem .1rem 1rem;background: rgba(0,0,0,.4);border-radius: .5rem;}
  .comment-animate-img{position:absolute;left:.16rem;top:.1rem;width: .66rem;height: .66rem;border:.01rem solid #eee;border-radius: 50%;}
  .comment-animate-text{position: relative;top:50%;line-height:.32rem;font-size:.26rem;color:#fff;transform: translateY(-50%);overflow: hidden;}
  .comment-animate-text span{display:inline-block;line-height:.32rem;}
  .comment-animate-text.hide2{ display: -webkit-box !important;overflow : hidden;height:.64rem;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
  .comment-animate-con{opacity: 1;}
  .comment-animate{opacity: 0;transform: translate(-.8rem,.3rem);}
  .swiper-slide-active .comment-animate{animation:commentAnimate .2s linear .1s;animation-fill-mode: forwards; }
  @-webkit-keyframes commentAnimate {from{opacity: 0;-webkit-transform: translate(-.8rem,.3rem);}to{opacity: 1;-webkit-transform: translate(0,0);}}
  @keyframes commentAnimate {from{opacity: 0;transform: translate(-.8rem,.3rem);}to{opacity: 1;transform: translate(0,0);}}

  /*附近景区*/
  .list-tit{padding:.2rem 0;height:.36rem;color:#333;font-weight:bold;font-size:.32rem;line-height:.36rem}
  .list-tit span{float:left;margin-right:.12rem;width:.07rem;height:.36rem;background-color:#faaf39}
  .list-more{float:right;padding:0 .07rem;color:#555;font-size:.24rem}
  .conference-item-info-label img{width:.17rem;height:.26rem;vertical-align: middle;}
  .half .conference-item-parent{float: left;width:50%;}
  .half .conference-item-parent .conference-item{position: relative;margin-top: .2rem;background-color: #fff;border-radius: .15rem;}
  .half .conference-item-parent:nth-of-type(odd) .conference-item{padding-right:3%;}
  .half .conference-item-parent:nth-of-type(even) .conference-item{padding-left:3%;}
  .half .conference-item-parent .conference-item-img{position:relative;width:100%;height:2.7rem; border-radius: .08rem .08rem 0 0;overflow: hidden;}
  .half .conference-item-parent .conference-item-info{height:1rem; padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1);}
  .half .conference-item-parent .conference-item-title{font-weight: bold;color: #333;font-size:.26rem;}
  .half .conference-item-parent .label-box{width: 100%;height:.48rem; line-height: .48rem; padding-top: .08rem;}
  .half .conference-item-parent .right-info{width: 100%;text-align: left;}
  .half .conference-item-parent .icon-time {font-size: .22rem;margin-left: .07rem;font-weight: bold;color: #666;}

  /*购买成功后提示收藏弹窗*/
  .system-alert{position: fixed;z-index: 11;top:0;left: 0;width: 100vw;height: 100vh;background: rgba(0,0,0,.9);}
  .system-img{display: block;width: 70%;height: auto;margin: .8rem auto 0;}
  .system-btn{display: block;width: 2.32rem;height: .72rem;margin:.82rem auto;border: 1px dashed #fff;font: .28rem/.72rem "Microsoft YaHei"; border-radius: .1rem;text-align: center;color: #fff;}

  /*返回上一页按钮*/
  .link-btn{position: fixed;z-index:12;right:0;top:2rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}

  /*离线下载*/
  .download{position: absolute;right: .28rem;bottom: .13rem;height: .6rem;font: .24rem/.6rem "Microsoft YaHei";color: #666;}
  .icon-download{float: left;width: auto;height: .36rem;margin-top: .12rem;margin-right: .1rem;}
  .tip-download{margin: .34rem .27rem;font-size: .22rem;color: #909090;}

  /*关注*/
  .focus{width:100%;height: .75rem;background: rgba(0,0,0,.8);color: #fff;}
  .icon-focus{float: left;width: auto;height: .52rem;margin:.115rem .22rem 0 .27rem; }
  .focus-txt{float: left;width: 63%;font: .24rem/.75rem "Microsoft YaHei";letter-spacing: .02rem; }
  .focus-btn{float: right;width:1.15rem;height: .5rem;margin-top:.125rem;margin-right:.1rem;border: 1px solid #ffac56;color: #fff;font: .24rem/.5rem "Microsoft YaHei";color: #fff;
    text-align: center;border-radius: .3rem;-webkit-animation: focus 1.2s linear infinite;animation: focus 1.2s linear infinite;-webkit-transform: scale(.96);transform: scale(.96);}
  @-webkit-keyframes focus {
    0%{transform: scale(.96);}
    25%{transform: scale(1);}
    50%{transform: scale(.96);}
    75%{transform: scale(1);}
    100%{transform: scale(.96);}
  }
  @keyframes focus {
    0%{transform: scale(.96);}
    25%{transform: scale(1);}
    50%{transform: scale(.96);}
    75%{transform: scale(1);}
    100%{transform: scale(.96);}
  }

  /*语音swiper弹窗*/
  .alert-swiper{z-index:17;}
  .alert-swiper .blur-bg{position: absolute;top:0;left: 0;width: 100%;height: 100%;object-fit: cover;filter: blur(10px);}
  .alert-swiper .swiper-close{position: absolute;top:.4rem;right: .4rem;z-index: 9;width: .5rem;height: .5rem;}
  .alert-swiper .swiper-horizontal >>> .swiper-scrollbar {position: absolute;left: 1%;bottom: 0;z-index: 50;height: 5px;width: 98%;}
  .alert-swiper >>> .swiper-scrollbar-drag{background: rgba(255,255,255,.8);}
  .alert-swiper .swiper-container{position:absolute;top:50%;left:0;width: 100%;height: 60vw;margin-top: -35vw;}
  .alert-swiper .swiper-slide{height: 90%;background: #fff;border-radius: .3rem;overflow: hidden;}
  .alert-swiper .swiper-slide .bg{position: absolute;top:0;left: 0;width: 100%;height: 100%;object-fit: cover;border-radius: .3rem;overflow: hidden;}
  .alert-swiper .bot-con{position: absolute;bottom:0;left:0;width: 100%;height: 30%;background: #fff;border-radius: 0 0 .3rem .3rem;}
  .alert-swiper .bot-con .icon-btn{position: absolute;top: -.34rem;left: 50%;width: .8rem;height: .8rem;margin-left: -.4rem;background-image:none;}
  .alert-swiper .bot-con .icon-btn.curr{-webkit-animation: focus 2.4s linear infinite;animation: focus 2.4s linear infinite;}
  .alert-swiper .bot-con p{position:absolute;bottom:14%;left:5%;width: 90%;font: .28rem/.46rem "Microsoft YaHei";color: #333;text-align: center;}

</style>



// WEBPACK FOOTER //
// src/page/video-play/video-play.vue